// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../../utils/BasicAuthAPI";
import { Tabs, Radio, Row, Col } from "antd";
// import LineGraph from "src/components/LineDashboardV/Graph/LineChart";
// import LineGraph from "src/components/ManagerDashboard/Common/Graph/LineGraph";
import SpcLineGraph from "./Elements/SpcLineGraph";


// import BasicBarGraph from "./Common/Graph/BasicBarGraph";
import SpcClassIntervalBarGraph from "./Elements/SpcClassIntervalBarGraph";
import SpcCpk from "./Elements/SpcCpk";
import SpcPerformanceGaugeGraph from "./Elements/SpcPerformanceGaugeGraph";
// import LineGraphSpc from "src/components/Spc/Elements/LineGraphSpc";



// import ColoredBarGraph from "./Common/Graph/ColoredBarGraph";
// import GaugeGraph from "./Common/Graph/GaugeGraph";
// import "./managerDashboard.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
// E:\GIT\React\_DevOpsReact_01\src\components\LineDashboardV\Graph\PerformanceGaugeGraph.js



const DashboardTabs = {
  1: "SpcGraph",
  2: "Cpk",
  3: "DataTable"
};
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";
const productionTableStyle = {
  marginTop: "1rem",
  marginBottom: "1rem",
};

class Spc extends React.Component {
  state = {
    mainData: null,
    xData: null,
    rData: null,
    linePref: null,
    mtdData: null,
    spcClassIntervalData: null,
    loading: true,
    loginError: false,
    selectedTab: "1",
    SpcPerformanceGaugeGraph1: null,
    SpcPerformanceGaugeGraph2: null
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value, st);
  };

  componentDidMount() {
    

    this.props.setPageHeader("SPC");
    this._isMounted = true;
    this._isMounted && this.fetchTrendData(this.state.selectedTab);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab) => {
    liracrypt
      // .get("/mdash/trenddata", {
      //   lid: "lid_999",
      //   typ: "MainGraph",
      //   subTyp: DashboardTabs[selectedTab],
      // })



      .get("/textapi", { dn: "Spc" })
      .then(({ data }) => {
        


        const newData = { ...data };
        let newDataConfig = {};
        newDataConfig["xData"] = newData["data"]["xData"];
        newDataConfig["rData"] = newData["data"]["rData"];
        newDataConfig["spcClassIntervalData"] = newData["data"]["spcClassIntervalData"];
        newDataConfig["spcCpk"] = newData["data"]["spcCpk"];
        

        delete newData["data"]["linePerf"];
        newDataConfig["mainData"] = { ...newData };
        this._isMounted &&
          this.setState({
            ...this.state,
            ...newDataConfig,
            SpcPerformanceGaugeGraph1: newData['data'].SpcPerformanceGaugeGraph1,
            SpcPerformanceGaugeGraph2: newData['data'].SpcPerformanceGaugeGraph2,
            loading: false
          });
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div>
            <Radio.Group
              className="managerTabs"
              value={"small"}
              onChange={this.onChange}
            >
              {/* <Radio.Button
                className="SpcGraph"
                style={{
                  backgroundColor: "#262626",
                  color: "#9c27b0",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="1"
              >
                SpcGraph
              </Radio.Button> */}
              {/* <Radio.Button
                className="Cpk"
                style={{
                  backgroundColor: "#262626",
                  color: "#4D83FF",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="2"
              >
                CP/CPK
              </Radio.Button> */}
              {/* <Radio.Button
                className="DataTable"
                style={{
                  backgroundColor: "#262626",
                  color: "#7859DF",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="3"
              >
                Data
              </Radio.Button> */}


            </Radio.Group>
            {this.state.loading === false ? (
              <div
                style={
                  {
                    // border: "2px solid " + this.state.mainData.data.color,
                    // borderRadius: "10px",
                    // border: "2px solid #3b3b3b",
                    // borderTopColor: this.state.mainData.data.color,
                    // borderTopWidth: "3px",
                  }
                }
              >
                <Row>

                  <Col span={24}>


                    {this.state.xData ? (
                      <SpcLineGraph
                        divId={"linegraph01"}
                        title={"X-Bar Chart"}
                        category={"_id"}
                        data={this.state.xData}
                        rotation={270}


                        legendRdg={"Reading"}
                        colorRdg={"#ecf0f1"}
                        valRdg={"rdg"}

                        legendTgt={"Target"}
                        valTgt={"tgt"}
                        colorTgt={"#3498db"}

                        legendLcl={"LCL"}
                        valLcl={"lcl"}
                        colorLcl={"#e74c3c"}

                        legendUcl={"UCL"}
                        valUcl={"ucl"}
                        colorUcl={"#e74c3c"}

                        legendLsl={"LSL"}
                        valLsl={"lsl"}
                        colorLsl={"#2ecc71"}

                        legendUsl={"USL"}
                        valUsl={"usl"}
                        colorUsl={"#2ecc71"}




                      />
                    ) : null}
                  </Col>
                </Row>
                <Row>



                  <Col span={24}>


                    {this.state.xData ? (
                      <SpcLineGraph
                        divId={"linegraph02"}
                        title={"R Chart"}
                        category={"_id"}
                        data={this.state.xData}
                        rotation={270}

                        legendRdg={"Reading"}
                        colorRdg={"#ecf0f1"}
                        valRdg={"rdg"}

                        legendTgt={"Target"}
                        valTgt={"tgt"}
                        colorTgt={"#3498db"}

                        legendLcl={"LCL"}
                        valLcl={"lcl"}
                        colorLcl={"#e74c3c"}

                        legendUcl={"UCL"}
                        valUcl={"ucl"}
                        colorUcl={"#e74c3c"}

                        legendLsl={"LSL"}
                        valLsl={"lsl"}
                        colorLsl={"#2ecc71"}

                        legendUsl={"USL"}
                        valUsl={"usl"}
                        colorUsl={"#2ecc71"}




                      />
                    ) : null}
                  </Col>
                </Row>







                <Row>



                  <Col span={12}>
                    {this.state.spcClassIntervalData ? (
                      <SpcClassIntervalBarGraph
                        divId={"spc01"}
                        title={"Class Interval Distribution"}

                        colVal={"col"}
                        lineVal={"line"}
                        category={"_id"}
                        data={this.state.spcClassIntervalData}
                      />
                    ) : null}
                  </Col>

                  <Col span={12}>
                    {this.state.spcCpk ? (
                      <SpcCpk
                        divId={"spc-02"}
                        title={"CPk Distribution"}
                        colVal={"col"}
                        lineVal={"line"}
                        category={"_id"}
                        data={this.state.spcCpk}
                      />
                    ) : null}
                  </Col>



                </Row>

              

              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}



export default Spc;
